import { SxProps } from '@mui/material';

export const DpOutlinedSelectSX: SxProps = {
	fontSize: 'var(--font-size-body)',
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#C9C9C9',
	},
	height: '48px',
	'.MuiOutlinedInput-root': {
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#774A91',
	},
	'& .MuiSelect-iconOpen': {
		transform: 'none',
	},
	'.MuiSelect-nativeInput': {
		borderWidth: '1px !important',
	},
	'& .MuiFormLabel-asterisk': {
		display: 'none',
	},
	'.MuiSelect-outlined': {
		padding: '14px !important',
	},
};
